import { css } from "@emotion/css";
import { RadioRenderProps } from "react-aria-components";

interface Props extends RadioRenderProps {}

export function _RadioAsset(props: Props) {
  const { isSelected, isDisabled, isFocusVisible, isFocused, isHovered } =
    props;

  return (
    <div className={styles.container}>
      <div
        className={css(
          styles.checkbox,
          isHovered && {
            borderColor: "var(--border-input-hover)",
          },
          isFocused && {
            boxShadow: "var(--focus-action)",
          },
          isSelected && {
            borderColor: "var(--background-selected-strong)",
          },
          isDisabled && {
            cursor: "not-allowed",
            borderColor: "var(--background-selected-disabled)",
          },
          isFocusVisible && {
            boxShadow: "var(--focus-action)",
          }
        )}
      >
        {isSelected && (
          <div
            className={css(
              styles.dot,
              isDisabled && {
                backgroundColor: "var(--background-selected-disabled)",
              }
            )}
          />
        )}
      </div>
    </div>
  );
}

const styles = {
  container: css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    height: 20,
    justifyContent: "center",
    width: 20,
  }),
  checkbox: css({
    alignItems: "center",
    borderRadius: "var(--border-radius-half)",
    borderStyle: "solid",
    borderWidth: 2,
    boxSizing: "border-box",
    cursor: "pointer",
    display: "flex",
    height: 18,
    justifyContent: "center",
    width: 18,
    borderColor: "var(--border-input)",
  }),
  dot: css({
    borderRadius: "var(--border-radius-half)",
    height: 8,
    width: 8,

    backgroundColor: "var(--background-selected-strong)",
  }),
};
